// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const ColorPickerDiv = styled.div`
    position: relative;

    button:first-of-type, .MuiButtonGroup-firstButton {
        border-radius: 0 .25rem .25rem 0;
    }
`;

export const ColorBoxDiv = styled.div<{ disabled?: boolean }>`
    cursor: ${props => !props.disabled ? "pointer" : "not-allowed"};
    border: 1px solid #BEBEBE;
    border-radius: 4px;
    height: 40px;
`;

export const PickerContainer = styled.div`
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 1001;

    .compact-picker {
        & > .flexbox-fix {
            display: none !important;
        }
    }
`;
